import escape from '@/common/helpers/escape';
import emptyInnerHTML from '@/common/helpers/empty-inner-html';

export default function prepareViewHTML(html, language) {
    const codeClass = language ? ` class="${language}"` : '';
    return `<style>
pre {
    display: block;
    border-radius: 4px;
    box-shadow: 0 0 0 1px #E1E7EA;
    padding: 16px 16px 16px 16px;
    background: #F9FAFB;
    color: #6B7384;
    font-family: Roboto Mono, monospace;
    font-size: 12px;
    overflow: auto;
    white-space: pre-wrap;
    word-wrap: break-word;   
}
.hljs {
    display: inherit;
    overflow-x: inherit;
    padding: 0;
    background: inherit;
    white-space: inherit;
    font-weight: inherit;
    line-height: inherit;
}
.hljs,.hljs-subst {
    color: #444
}
.hljs-comment {
    color: #888888
}
.hljs-keyword,.hljs-attribute,.hljs-selector-tag,.hljs-meta-keyword,.hljs-doctag,.hljs-name {
    font-weight: bold
}
.hljs-type,.hljs-string,.hljs-number,.hljs-selector-id,.hljs-selector-class,.hljs-quote,.hljs-template-tag,.hljs-deletion {
    color: #880000
}
.hljs-title,.hljs-section {
    color: #880000;
    font-weight: bold
}
.hljs-regexp,.hljs-symbol,.hljs-variable,.hljs-template-variable,.hljs-link,.hljs-selector-attr,.hljs-selector-pseudo {
    color: #BC6060
}
.hljs-literal {
    color: #78A960
}
.hljs-built_in,.hljs-bullet,.hljs-code,.hljs-addition {
    color: #397300
}
.hljs-meta {
    color: #1f7199
}
.hljs-meta-string {
    color: #4d99bf
}
.hljs-emphasis {
    font-style: italic
}
.hljs-strong {
    font-weight: bold
}
</style>
<pre><code${codeClass}>${html ? escape(html) : emptyInnerHTML}</code></pre>`;
}
